import { Injectable } from '@angular/core';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';
import { PaymentCardDto } from '../dtos';

@Injectable()
export class PaymentCardsService {
  private path = 'paymentcards';
  constructor(private httpService: HttpService) {}

  public getPaymentCards(): Observable<PaymentCardDto[]> {
    return this.httpService.makeGet<PaymentCardDto[]>(this.path, null, null);
  }

  public deletePaymentCard(PaymentCardID: number): Observable<void> {
    return this.httpService.makePost<void,void>('deletepaymentcard', null, null, {"PaymentCardID": PaymentCardID.toString()});
  }
}
